
const MoneyFormatter = ({ value }) => {
    // Configurar el formateador.
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    // Verificar si el valor es undefined o null y asignar 0 en ese caso.
    const validValue = value == null ? 0 : value;

    // Formatear el valor.
    const formattedValue = formatter.format(validValue);

    // Renderizar el valor formateado.
    return <span>{formattedValue}</span>;
};

export default MoneyFormatter;